import { render, staticRenderFns } from "./projectManagementPage.vue?vue&type=template&id=6f3531cd"
import script from "./projectManagementPage.vue?vue&type=script&lang=js"
export * from "./projectManagementPage.vue?vue&type=script&lang=js"
import style0 from "./projectManagementPage.vue?vue&type=style&index=0&id=6f3531cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports